import { Divider, LayoutContainer } from "@relode/core";
import * as React from "react";

import { useJobContext } from "../../../_infra";
import { JobCandidates } from "./jobCandidates";
import { JobEngagement } from "./jobEngagement";
import { JobMarketResearch } from "./jobMarketResearch";
import { JobMarketResearchMarketing } from "./jobMarketResearchMarketing";
import { JobStats } from "./jobStats";

export const JobInsights = () => {
    const {
        actions,
        state: {
            data: { job },
        },
    } = useJobContext();

    return (
        <LayoutContainer>
            <JobCandidates />
            <Divider gutterBottom gutterTop />
            <JobEngagement />
            <Divider gutterBottom gutterTop />
            <JobStats />
            {!!job?.details?.showMarketResearchData ? (
                <>
                    <Divider gutterBottom gutterTop />
                    <JobMarketResearch />
                </>
            ) : null}
            {!!job?.details?.showMarketResearchMarketing ? (
                <>
                    <Divider gutterBottom gutterTop />
                    <JobMarketResearchMarketing job={job} />
                </>
            ) : null}
        </LayoutContainer>
    );
};
